export default "__VITE_ASSET__BSMpbn7X__"